import axios from 'axios';
import AppConfig from '../app_config';
import 'regenerator-runtime/runtime';

export const insertGlobalConfigInDom = async (config: AppConfig) =>
  axios
    // eslint-disable-next-line
    .get(config?.CONFIG_URL!)
    .then((response) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(response.data, 'text/html');
      const configModel = doc.querySelector('#config-model');

      if (configModel) {
        // Convert the element to an HTML string
        const configModelHtml = configModel.outerHTML;

        // Append the HTML string to the body of the current document
        // eslint-disable-next-line @microsoft/sdl/no-inner-html
        document.body.insertAdjacentHTML('beforeend', configModelHtml);
      } else {
        throw new Error('Element with id "config-model" not found.');
      }
    })
    .catch((error) => {
      console.error('Error fetching the config-model:', error);
      throw error;
    });

export const loadAnalyticCode = async () => {
  const runMode = document.querySelector<HTMLInputElement>('#config-model input[name="runMode"]')?.value;
  const activateGTM = document.querySelector<HTMLInputElement>('#config-model input[name="activateGTM"]')?.value;
  const gtmId = document.querySelector<HTMLInputElement>('#config-model input[name="gtm.id"]')?.value;
  const activateAdobeLaunch = document.querySelector<HTMLInputElement>(
    '#config-model input[name="activateAdobeLaunch"]'
  )?.value;
  const adobeLaunchID = document.querySelector<HTMLInputElement>('#config-model input[name="adobeLaunch.id"]')?.value;
  const adobeLaunchIntegrity = document.querySelector<HTMLInputElement>(
    '#config-model input[name="adobeLaunchIntegrity"]'
  )?.value;

  if (runMode === 'publish' && activateGTM === 'true') {
    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.textContent = `(function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
          'gtm.start':
              new Date().getTime(), event: 'gtm.js'
      });
      var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src =
          '//www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${gtmId}');`;
    document.head.appendChild(gtmScript);
  }

  if (activateAdobeLaunch === 'true' && adobeLaunchID && adobeLaunchIntegrity) {
    const adobeScript = document.createElement('script');
    adobeScript.src = encodeURI(adobeLaunchID);
    adobeScript.integrity = adobeLaunchIntegrity;
    adobeScript.async = true;
    adobeScript.crossOrigin = 'anonymous';
    document.head.appendChild(adobeScript);
  } else if (activateAdobeLaunch === 'true' && adobeLaunchID) {
    const adobeScript = document.createElement('script');
    adobeScript.src = encodeURI(adobeLaunchID);
    adobeScript.async = true;
    document.head.appendChild(adobeScript);
  }

  if (runMode !== 'publish') {
    const publishScript = document.createElement('script');
    publishScript.textContent = 'window.dataLayer = window.dataLayer || [];';
    document.head.appendChild(publishScript);
  }
};

export default insertGlobalConfigInDom;
